// Broker report field-fallback chains — single place to add a new broker's
// field name. Extracted from 5+5+2 hand-copied chains in routerReports.js
// (dedup audit 2026-07-17, item 3a). Blast radius: logging/toast/display —
// the raw report itself is always forwarded intact.

export const extractOrderSide = (report) =>
  (
    report.side ||
    report.orderType ||
    report.type ||
    report.action ||
    "BUY"
  ).toUpperCase();

export const extractQuantity = (report) =>
  report.quantity ||
  report.qty ||
  report.qtt ||
  report.amount ||
  report.vol ||
  1;

export const extractAvgPrice = (report) =>
  report.avgPrice ||
  report.price ||
  report.avg_price ||
  report.avgPice || // typo real vindo do wire — preservado de propósito
  report.executionPrice ||
  report.fillPrice ||
  report.lastPrice ||
  "N/A";
